<template>
    <Toast />
    <router-view />
</template>

<script  lang="ts">
export default {
    name : 'AdminLayout'
}
</script>